export default "__VITE_ASSET__519d1bf6__"